import React from 'react';
import { Box, Grid } from '@mui/material';
import { useStatusBarStore, useUserStore } from 'stores';
import SparkRunResults from './SparkRunResults';
import SparRunFormContainer from './SparRunFormContainer';
import { motion } from 'framer-motion';
import SparkRunErrorModal from './SparkRunErrorModal';
import SparkRunStatus from 'components/common/StatusBar/SparkRunStatus';

type SparkRunsContentTypeProps = {
  sparkID: string;
};

function SparkRunsContent({ sparkID }: SparkRunsContentTypeProps) {
  const [collectiveSparkRunIDs, setCollectiveSparkRunIDs] = React.useState<
    string[]
  >([]);

  const currentUserID = useUserStore(
    React.useCallback((state) => state.currentUserID, [])
  );
  const isAttempted = useStatusBarStore(
    React.useCallback((state) => state.isAttempted, [])
  );
  const isPendingPayment = useStatusBarStore(
    React.useCallback((state) => state.isPendingPayment, [])
  );
  const statusBarType = useStatusBarStore(
    React.useCallback((state) => state.statusBarType, [])
  );
  const secondaryStatusID = useStatusBarStore(
    (state) => state.secondaryStatusID
  );

  const addToSparkRunIDsCollection = React.useCallback((sparkRunID: string) => {
    setCollectiveSparkRunIDs((prev) => [...prev, sparkRunID]);
  }, []);

  const shouldRenderResults =
    !!isAttempted &&
    !isPendingPayment &&
    statusBarType === 'sparkRun' &&
    sparkID === secondaryStatusID &&
    !!currentUserID;

  const shouldRenderForm = !shouldRenderResults;
  return (
    <Grid container item flex={1} justifyContent='center'>
      <Grid
        item
        container
        position='relative'
        component={motion.div}
        initial={{ height: 'auto' }}
        animate={{
          height: shouldRenderForm ? '100%' : 0,
          display: shouldRenderForm ? 'block' : 'none',
        }}
        style={{
          overflow: 'hidden',
          display: shouldRenderForm ? 'block' : 'none',
          maxWidth: '800px',
          width: '100%',
        }}
        transition={{
          duration: 0.3,
          ease: 'easeInOut',
          delay: 0.5,
        }}
      >
        <SparRunFormContainer
          addToSparkRunIDsCollection={addToSparkRunIDsCollection}
          shouldRenderForm={shouldRenderForm}
          actionContainerStyles={{
            position: 'fixed',
            maxWidth: '800px !important',
            width: '100%',
            margin: 'auto',
            zIndex: 13,
            display: shouldRenderResults ? 'none' : 'block',
          }}
        />
      </Grid>

      <Grid
        item
        component={motion.div}
        initial={{ height: 0, display: 'none' }}
        animate={{
          height: shouldRenderResults ? 'auto' : 0,
          display: shouldRenderResults ? 'flex' : 'none',
        }}
        transition={{
          duration: 1,
          ease: 'easeInOut',
          delay: 1,
        }}
        style={{ overflow: 'hidden', width: '100%' }}
      >
        {shouldRenderResults && (
          <Box width='100%' justifyItems='center'>
            <SparkRunStatus
              containerStyles={{
                alignContent: 'center',
                width: '100%',
                height: '4rem',
              }}
            />
            <Box sx={{ maxWidth: '800px', width: '100%' }}>
              <SparkRunResults
                collectiveSparkRunIDs={collectiveSparkRunIDs}
                addToSparkRunIDsCollection={addToSparkRunIDsCollection}
                sparkID={sparkID}
              />
            </Box>
          </Box>
        )}
      </Grid>
      <SparkRunErrorModal />
    </Grid>
  );
}

export default SparkRunsContent;
